<template>
  <Layout>
    <form @submit.prevent>
      <!-- <language-switch class="lang" /> -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h3 class="text-dark">TuneSoft</h3>
                    <h5 class="text-primary">
                      {{ $t("auth.login") }}
                    </h5>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img :src="whiteLabel || require('@/assets/images/logo-small.png')" :class="['rounded-circle', whiteLabel ? 'w-100 h-100' : '']" height="60" />
                  </span>
                </div>
              </div>

              <sweet-input
                :isValid="!$v.form.email.$error"
                @input="$v.form.email.$touch()"
                v-model="form.email"
                type="email"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.email')"
                :label="$t('common.email')"
              />

              <sweet-input
                :isValid="!$v.form.password.$error"
                @input="$v.form.password.$touch()"
                v-model="form.password"
                type="password"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.password')"
                :label="$t('common.password')"
                labelClass="mt-2"
              />
              <div v-if="enableRecaptcha" class="mt-3">
                <vue-recaptcha ref="recaptcha" @verify="handleRecaptchaVerify" :sitekey="recaptchaKey" size="invisible"> </vue-recaptcha>
                <b-button type="submit" @click="tryToLogIn" variant="primary" block :disabled="$v.form.$invalid">
                  <i class="bx bx bxs-key font-size-24 align-middle mr-2"></i>
                  {{ $t("auth.login") }}
                </b-button>
              </div>

              <div v-else class="mt-3">
                <b-button type="submit" variant="primary" block @click="tryToLogIn" :disabled="requested || $v.form.$invalid">
                  <i class="bx bx bxs-key font-size-24 align-middle mr-2"></i>
                  {{ $t("auth.login") }}
                </b-button>
              </div>

              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i>
                  {{ $t("auth.forgot-password-question") }}
                </router-link>
              </div>
              <div class="mt-4 text-center">
                <p>
                  {{ $t("account.dont-have-an-account") }}
                  <router-link tag="a" to="/register" class="font-weight-medium text-primary">{{ $t("account.signup") }}</router-link>
                </p>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <div class="mt-5 text-center">
            <p>© {{ new Date().getFullYear() }} Tunesoft</p>
          </div>

          <div class="mt-5 text-center text-muted">
            <span class="mr-2">powered by </span>
            <a href="https://phexum.com?ref=tunesoft" target="_blank">
              <img src="@/assets/images/phexum-logo.png" alt height="20" />
            </a>
          </div>
          <!-- end row -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </form>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/account/auth";

import { VueRecaptcha } from "vue-recaptcha";
import { email, required } from "vuelidate/lib/validators";

/**
 * Login component
 */

export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, VueRecaptcha },
  data() {
    return {
      requested: false,
      form: { email: undefined, password: undefined },
      formError: undefined,
    };
  },
  computed: {
    recaptchaKey() {
      return this.$store.getters["clientConfig/recaptchaKey"];
    },
    enableRecaptcha() {
      return this.$store.getters["clientConfig/enableRecaptcha"];
    },
  },
  validations: {
    form: {
      password: {
        required,
      },

      email: {
        required,
        email,
      },
    },
  },

  methods: {
    async tryToLogIn() {
      if (this.enableRecaptcha) {
        this.$refs.recaptcha.reset();
        this.$refs.recaptcha.execute();
      } else {
        await this.submit();
      }
    },
    async submit() {
      try {
        this.requested = true;

        await this.$store.dispatch("user/login", this.form);
        this.$store.commit("switchWorkspace/selected", null);
        window.location.href = "/";
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        setTimeout(() => (this.requested = false), 1000);
      }
    },
    async handleRecaptchaVerify(response) {
      if (response) {
        try {
          await this.submit();
        } catch (error) {
          console.error("Form submission error", error);
        }
      }
    },
    anyError(e) {
      this.formError = e;
    },
  },
};
</script>
<style scoped></style>
